<template>
    <okraina-view :class="'okraina-vcard'" ref="view">
        <template v-slot:header>
            <h1 class="title">
                Моя визитка
            </h1>
        </template>
        <template v-slot:content>
            <div class="okraina-vcard" ref="view" :hideMenu="true">
                <div class="wrapper" v-if="user.URL_VCARD">

                    <div class="qr">
                        <qrcode-vue :value="user.URL_VCARD" :size="size" level="H" render-as="svg" />
                    </div>

                    <div class="button">
                        <div class="btn-block btn btn3 slim" @click="share()">Поделиться</div>
                    </div>

                </div>
            </div>
        </template>
    </okraina-view>
</template>

<script>
import okrainaView from "@/components/view2.vue";
import QrcodeVue from 'qrcode.vue'

import { mapGetters } from "vuex";
import bus from "@/plugins/bus";

export default {
    name: "okraina-vcard",
    components: {
        QrcodeVue,
        okrainaView
    },
    computed: {
        ...mapGetters({
            user: "getUser",
        }),
    },
    data() {
        return {
            size: 250
        }
    },
    methods: {
        /**
         * Поделиться
         */
         share() {
            bus.emit("OKRAINA_APP_E_SHARE", {
                title: 'Поделиться',
                text: this.user.NAME+' '+this.user.LAST_NAME,
                url: this.user.URL_VCARD,
                dialogTitle: 'Поделиться',
            });
        },
    },
}

</script>

<style lang="scss">
.okraina-vcard {
    position: relative;
    height: 100%;
    .wrapper{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, 50%);
        .qr{
            background-color: #fff;
            border-radius: 20px;
            padding: 2rem;
        }
        .button{
            padding-top: 15px;
        }
    }
}
</style>